import { render } from "./Team_legal_en_m.vue?vue&type=template&id=1901c1b0&scoped=true"
import script from "./Team_legal_en_m.vue?vue&type=script&lang=js"
export * from "./Team_legal_en_m.vue?vue&type=script&lang=js"

import "./Team_legal_en_m.vue?vue&type=style&index=0&id=1901c1b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1901c1b0"

export default script